import classNames from 'classnames'
import ImageWithBasePath from '../components/ImageWithBasePath'

export const AdvertiserSecondaryButton = ({
  icon,
  title,
  className = 'border-[1px]',
  onClick = () => {},
  imageClass = 'mr-[1.91px]',
  imageDetails = { width: 16, height: 16 },
  imageAfterTitle = false,
  titleClassName = ''
}) => {
  return (
    <div
      className={classNames(
        'flex h-[40px] w-[100%] items-center justify-center rounded-[3px]  border-solid  px-[22px] pt-[8.5px] pb-[9.5px]',
        className
      )}
      onClick={onClick}
      id="secondary_button_container"
    >
      {icon && !imageAfterTitle && (
        <div className={classNames('flex items-center', imageClass)} id="secondary_button_icon">
          <ImageWithBasePath
            src={icon}
            height={imageDetails?.width}
            width={imageDetails?.height}
            alt="button icon"
          />
        </div>
      )}
      <div
        className={classNames('text-[14px] font-bold text-black', titleClassName)}
        id="secondary_button_title"
      >
        {title}
      </div>
      {imageAfterTitle && icon && (
        <div className={classNames('flex items-center', imageClass)} id="secondary_button_icon">
          <ImageWithBasePath
            src={icon}
            height={imageDetails?.width}
            width={imageDetails?.height}
            alt="button icon"
          />
        </div>
      )}
    </div>
  )
}
